// RequireAuth — route guard for the authenticated app shell. While the session
// is re-bootstrapping from a persisted id we hold with a spinner; with no session
// we redirect to /login (preserving where the user was headed so login can return
// them there). This is the route-level half of the auth seam; inline gates (<Can>)
// arrive with real authorization (FRONTEND_RULES Rule 5).
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import { Spinner } from '../components/reusable';
import { useAuth } from './AuthProvider';

export function RequireAuth({ children }) {
  const { status, isAuthenticated } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return <Spinner size="lg" label="Loading your account" />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}

RequireAuth.propTypes = {
  children: PropTypes.node,
};

export default RequireAuth;
